var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92412 19.5871C13.4403 16.313 18.4523 14.1545 20.96 13.1117C28.1201 10.1341 29.6079 9.61687 30.5777 9.59979C30.791 9.59604 31.2679 9.64888 31.5768 9.89949C31.8376 10.1111 31.9094 10.397 31.9437 10.5976C31.9781 10.7982 32.0208 11.2553 31.9868 11.6124C31.5988 15.6885 29.9199 25.58 29.0658 30.1453C28.7043 32.077 27.9927 32.7247 27.3038 32.7881C25.8065 32.9259 24.6696 31.7988 23.2194 30.8484C20.9502 29.3612 19.6682 28.4354 17.4656 26.9841C14.92 25.307 16.5702 24.3852 18.0209 22.8787C18.4006 22.4844 24.9975 16.4852 25.1252 15.941C25.1411 15.8729 25.1559 15.6192 25.0052 15.4852C24.8544 15.3512 24.6319 15.3971 24.4714 15.4335C24.2438 15.4851 20.6187 17.8807 13.5961 22.6203C12.5671 23.3267 11.6351 23.6709 10.8 23.6529C9.87947 23.633 8.10865 23.1325 6.79223 22.7046C5.17759 22.1799 3.89431 21.9024 4.00605 21.0112C4.06425 20.5471 4.70361 20.0723 5.92412 19.5871Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c0d0c1741a90ea8db5ef23ccc837b183.svg";
export { ForwardRef as ReactComponent };